module.exports = __webpack_public_path__ + "static/media/appInfo1.e2120ee0.png";